import React, { useEffect, useState } from "react"
import {
  Button,
  Col,
  FormGroup,
  Input,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
} from "reactstrap"
import axios from "axios"
import { useFormik } from "formik"
import * as Yup from "yup"
import { useHistory } from "react-router-dom"
import { error } from "toastr"
import { Label } from "recharts"

const AddProjectData = ({
  addToggle,
  setAuth,
  setInsertedDataResult,
  setInsertedDataResultType,
  insertedDataResultToggle,
}) => {
  const history = useHistory()

  const [modal, setmodal] = useState(true)
  const toggle = () => addToggle()
  const onClose = () => addToggle()

  const [file, setFile] = useState(null)
  const [policyNo, setPolicyNo] = useState("")
  const [surveyNo, setSurveyNo] = useState("")
  const [email, setEmail] = useState("")
  const [mobile, setMobile] = useState("")
  const [submitLoading, setSubmitLoading] = useState(false)

  const [errors, setErrors] = useState({
    general: "",
    file: "",
    policyNo: "",
    surveyNo: "",
    email: "",
    mobile: "",
  })

  //   console.log("file", file)
  //   console.log("policyNo", policyNo)
  //   console.log("surveyNo", surveyNo)

  console.log("errors", errors)

  useEffect(() => {
    setErrors({
      file: "",
      policyNo: "",
      surveyNo: "",
      email: "",
      mobile: "",
    })

    if (!file && !policyNo && !surveyNo) {
      setErrors(errors => ({
        ...errors,
        general: "Kindly provide either file or (policy no & survey no)",
      }))
    }

    if (!file && policyNo && !surveyNo) {
      setErrors(errors => ({ ...errors, surveyNo: "required" }))
    }

    if (!file && !policyNo && surveyNo) {
      setErrors(errors => ({ ...errors, policyNo: "required" }))
    }

    if (email && !/^[\w.%+-]+@[\w.-]+\.[A-Za-z]{2,}$/.test(email)) {
      setErrors(errors => ({ ...errors, email: "invalid" }))
    }

    if (mobile && !/^\d{10,}$/.test(mobile)) {
      setErrors(errors => ({ ...errors, mobile: "invalid" }))
    }
  }, [file, policyNo, surveyNo, email, mobile])

  const submitHandler = () => {
    setSubmitLoading(true)

    const formData = new FormData()
    formData.append("PerToken", localStorage.getItem("token"))
    formData.append("PerUserID", localStorage.getItem("id"))
    formData.append("PerRoleID", localStorage.getItem("userRoleID"))

    if (email) formData.append("Email", email)
    if (mobile) formData.append("Mobile", mobile)

    if (email && !/^[\w.%+-]+@[\w.-]+\.[A-Za-z]{2,}$/.test(email)) {
      return setErrors(errors => ({ ...errors, email: "invalid" }))
    }

    if (mobile && !/^\d{10,}$/.test(mobile)) {
      return setErrors(errors => ({ ...errors, mobile: "invalid" }))
    }

    if (file) {
      formData.append("File", file)
    } else if (policyNo && surveyNo) {
      formData.append("PolicyNo", policyNo)
      formData.append("ArealDecisionNumber", surveyNo)
    } else {
      return setErrors(errors => ({
        ...errors,
        general: "Kindly provide either file or (policy no & survey no)",
      }))
    }

    axios
      .post(
        process.env.REACT_APP_API_URL + "api/amanat/AddReports.php",
        formData
      )
      .then(res => {
        if (res.data.error === true && res.data.message === "Access denied!") {
          setAuth(true)
          setTimeout(() => {
            history.push("/logout")
            setTimeout(() => history.push("/login"), 1000)
          }, 4000)
          return
        }

        console.log("Response:", res.data)
        // Handle success
        addToggle()
        // duplicates
        if (res.data.results || res.data.duplicates) {
          if (file) {
            setInsertedDataResult(res.data.results)
            setInsertedDataResultType("file")
          } else {
            setInsertedDataResult(res.data.duplicates)
            setInsertedDataResultType("manual")
          }
          insertedDataResultToggle()
        }
      })
      .catch(err => {
        console.log("Error:", err)
        // Handle error
      })
      .finally(() => setSubmitLoading(false))
  }

  return (
    <Modal isOpen={modal} toggle={toggle} className="modal-lg">
      <ModalHeader>
        Add Project Data
        <button
          type="button"
          className="btn-close position-absolute end-0 top-0 m-3"
          onClick={onClose}
        />
      </ModalHeader>

      <ModalBody>
        <Row className="my-3">
          <Col sm={3} className="d-flex align-items-center">
            <label htmlFor="email" className="mx-3">
              Email
            </label>
          </Col>
          <Col sm={9}>
            <Input
              id="email"
              name="email"
              type="email"
              placeholder="Enter your email"
              value={email}
              onChange={e => setEmail(e.target.value)}
            />
            <span className="text-danger d-flex justify-content-end">
              {errors.email}
            </span>
          </Col>
        </Row>
        <Row className="my-3">
          <Col sm={3} className="d-flex align-items-center">
            <label htmlFor="mobile" className="mx-3">
              Mobile
            </label>
          </Col>
          <Col sm={9}>
            <Input
              id="mobile"
              name="mobile"
              type="tel"
              placeholder="Enter your mobile number"
              value={mobile}
              onChange={e => setMobile(e.target.value)}
            />
            <span className="text-danger d-flex justify-content-end">
              {errors.mobile}
            </span>
          </Col>
        </Row>

        <Row className="my-3">
          <Col sm={3} className="d-flex align-items-center">
            <label
              style={{ cursor: "pointer" }}
              htmlFor="file"
              className="mx-3"
            >
              Upload new list
            </label>
          </Col>
          <Col sm={9}>
            <Input
              type="file"
              id="file"
              accept=".xls,.xlsx,.csv"
              onChange={e => {
                setFile(e.target.files[0])
              }}
            />
          </Col>
        </Row>

        <Row className="my-5">
          <Col sm={6}>
            <label>Policy No</label>
            <Input
              type="number"
              value={policyNo}
              onChange={e => {
                setPolicyNo(e.target.value)
              }}
            />
            <span className="text-danger d-flex justify-content-end">
              {errors.policyNo}
            </span>
          </Col>
          <Col sm={6}>
            <label>Survey No</label>
            <Input
              type="number"
              value={surveyNo}
              onChange={e => setSurveyNo(e.target.value)}
            />
            <span className="text-danger d-flex justify-content-end">
              {errors.surveyNo}
            </span>
          </Col>
        </Row>

        <Row>
          <span className="text-danger d-flex justify-content-end">
            {errors.general}
          </span>
        </Row>

        <Row className="mb-3">
          <Col sm={12} className="d-flex justify-content-end">
            <Button
              disabled={submitLoading}
              type="submit"
              onClick={submitHandler}
            >
              Submit
            </Button>
          </Col>
        </Row>
      </ModalBody>
    </Modal>
  )
}

export default AddProjectData
